import * as React from 'react'

import EmptyList from 'modules/core/components/EmptyList'
import { Table } from 'modules/core/components/Table'
import type { WithMultiSelectStateChildrenProps } from 'modules/core/components/WithMultiSelectState'
import i18n from 'modules/core/lib/i18n'

import type { ImportedEmployee } from 'modules/employees/lib/ImportedEmployee'

import Content from '../Content'

type WithMultiSelectProps = WithMultiSelectStateChildrenProps<ImportedEmployee>

interface Props {
  employees: ImportedEmployee[]
  selected: ImportedEmployee[]
  attributes: string[]
  customFields: string[]
  onToggleSelectedItem: WithMultiSelectProps['onToggleSelectedItem']
  onDeselectAll: () => void
  onSelectAll: () => void
  tabId: 'conflicts' | 'errored' | 'ready'
}

const EmployeesTable = ({
  employees,
  selected,
  attributes,
  customFields,
  onToggleSelectedItem,
  onDeselectAll,
  onSelectAll,
  tabId,
}: Props) => {
  if (employees.length === 0) {
    const getDescription = () => {
      switch (tabId) {
        case 'conflicts':
          return i18n.t('import.blank_slate.conflicts')
        case 'errored':
          return i18n.t('import.blank_slate.errored')
        default:
          return i18n.t('import.blank_slate.ready')
      }
    }

    return <EmptyList description={getDescription()} squared />
  }

  return (
    <Table withTabs withHeight>
      <Content
        employees={employees}
        selected={selected}
        attributes={attributes}
        customFields={customFields}
        onToggleSelectedItem={onToggleSelectedItem}
        onDeselectAll={onDeselectAll}
        onSelectAll={onSelectAll}
      />
    </Table>
  )
}

export default EmployeesTable
